import { useParams } from 'react-router-dom'
import useTwinTranslation from '../../../../../utils/hooks/useTwinTranslation'
import { ComponentTabObject } from '../../../../../utils/hooks/useTabLogic'
import EditCardTabs from '../../../../../baseComponents/EditCardTabs'
import AllNotifications from './tabs/AllNotifications'

interface NotificationsProps {}

const Notifications: React.FC<NotificationsProps> = () => {
    const params = useParams<{ tab?: string }>()
    const { t } = useTwinTranslation() 
    const tabs: ComponentTabObject = {
        'all': { component: AllNotifications, text: t('all', 'Todas'), extraProps: {tableName: 'all'} },
        'timeControl': { component: AllNotifications, text: t('timeControl', 'Control horario'), extraProps: { where: { logType: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 28, 29, 30, 31, 32, 33, 34, 35, 36] }, tableName: 'timeControl' }, modules: ['working_calendar_full'] },
        'projects': { component: AllNotifications, text: t('project', 'Projecto'), extraProps: { where: { logType: [16, 17, 24] }, tableName: 'projects' } },
        'tasks': { component: AllNotifications, text: t('task', 'Tarea'), extraProps: { where: { logType: [18, 19, 20, 21, 22, 23] }, tableName: 'tasks' }, modules: ['tasks'] },
        'quoteOrders': { component: AllNotifications, text: t('quoteOrders', 'Presupuestos'), extraProps: { where: { logType: [39, 40, 41, 42] }, tableName: 'quoteOrders' }, modules: ['quotes'] },
        'expenses': { component: AllNotifications, text: t('expenses', 'Gastos'), extraProps: { where: { logType: [11, 12, 13, 14, 15] }, tableName: 'expenses' }, modules: ['employee_expenses'] },
    }

    return (<EditCardTabs basePath={'/notifications'} tabs={tabs} tab={params.tab} userPermissions={{ n: 4, permission: 'delete' }} basicData={[]} getData={async () => {}} />)
}

export default Notifications